import React, {PureComponent} from "react";
import {TextField as MUITextField, Tooltip} from "@material-ui/core";
import {restrictMaximumCharacters} from "./util";
import {GreyLockIcon} from "./GreyStyleIcon";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import {styles} from "./styles";
import {traceRenderStart} from "./Trace";
import {ConfirmButton} from "./ConfirmButton";
import {StyledTooltip} from "./TooltipError";

const COMPONENT = 'EditableTextArea.jsx'
//this is to hide scrollbar without this global scrollbar styles add scroll
const MUITextFieldStyled = withStyles({
    root: {
        '& .MuiOutlinedInput-input::-webkit-scrollbar': {
            width : '0px',

        },
        '& .MuiOutlinedInput-multiline' : {
            paddingRight : '4px'
        }

    }
})(MUITextField);

class EditableTextArea extends PureComponent {
    constructor(props) {
        super(props);
        let {value} = props;
        this.state = {
            value : value,
            error : '',
            rows: props.fullHeight ? undefined : 1
        }
    }

    setRef = (input) => {
        this.inputRef = input
    }

    handleKeyEvent = (ev) => {
        let {error, value} = this.state;
        let {label, validator, maxLength} = this.props;

        if (ev.ctrlKey && ev.key === 'Enter' && !error) {
            let error = validator ? validator(value, label, maxLength) : undefined;
            if (!error) {
                this.props.onConfirm(label, value, ev);
            }
        } else if(ev.key === 'Escape') {
            this.handleCancelEdit(ev);
        }
    }

    handleCancelEdit = (event) => {
        const {fullHeight} = this.props;
        const {target: {name, value}} = event;
        if(value !== this.props.value) {
            this.setState({value: this.props.value});
        }
        this.setState({error : '', rows : fullHeight ? undefined : 1})
    }

    render() {
        traceRenderStart("", COMPONENT)
        let {classes, helpMessage, checkConfirmOnKeyDown, fullHeight, theme, label, validator, maxLength, inputLabelProps, fullWidth, readOnly, onChange} = this.props;
        let {value, error, rows} = this.state;
        helpMessage = helpMessage ||(checkConfirmOnKeyDown && "Ctrl + Enter to confirm");
        let helpOpen = helpMessage && !readOnly && !error && this.props.value !== value;
        return <StyledTooltip open={error || helpOpen ? true : false} placement={'bottom'} title={error || helpMessage}>
            <MUITextFieldStyled
                datatest={'textareaField-'+label}
                margin={'dense'}
                multiline={true}
                error={error ? true : false}
                rows={rows}
                fullWidth={fullWidth === undefined ? true : fullWidth}
                label={label}
                value={value}
                onChange={(event) => {
                    let newEvent = restrictMaximumCharacters(event, maxLength);
                    const {target: {name, value}} = newEvent;
                    let error = validator(value, label, maxLength);
                    this.setState({error : error, value: value});
                }}
                onFocus={() => {
                    this.setState({rows : undefined}, () => this.inputRef.focus());
                }}
                onBlur={this.handleCancelEdit}
                onKeyDown={(ev) => {
                    if(checkConfirmOnKeyDown !== true) {
                        return;
                    }
                    this.handleKeyEvent(ev);
                }}
                inputProps={{
                    ref: this.setRef
                }}
                InputProps={{
                    endAdornment: readOnly
                        ? <GreyLockIcon theme={theme}/>
                        : (error || this.props.value === value)
                            ? undefined
                            : <ConfirmButton onClick={() => {
                                this.props.onConfirm(label, value);
                            }}/>
                    ,
                    readOnly: readOnly
                }}
                InputLabelProps={{shrink: true}}

            />
        </StyledTooltip>;
    }

}

EditableTextArea.propTypes = {
    readOnly: PropTypes.bool,
    value: PropTypes.string,
    helpMessage: PropTypes.string,
    label: PropTypes.string,
    fullWidth: PropTypes.bool,
    fullHeight: PropTypes.bool,
    checkConfirmOnKeyDown: PropTypes.bool,
    validator: PropTypes.func,
    maxLength: PropTypes.number,
    onConfirm: PropTypes.func
};

export default withStyles(styles, {withTheme: true})(EditableTextArea);
